import React from 'react';
import CTALink from '../../buttons/CTALink';
import { useTranslation } from 'react-i18next';

export const ReturnToBookingPortal = ({ to }: { to: string }) => {
	const { t } = useTranslation();
	return <CTALink text={t('actions.return_to_booking_portal')} to={to} />;
};
